module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-wrap"
  }, [_c('div', {
    staticClass: "map",
    on: {
      "click": _vm.jumpChild
    }
  }, [(!_vm.ifSatellite) ? _c('mapChart') : _c('satelliteMap')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a754232!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/secondMap/center/centerChildMap/index.vue
// module id = 2030
// module chunks = 2